import { requestJson } from "../lib/api";

export function getRanking(params = {}) {
  const searchParams = new URLSearchParams();

  if (params.page != null) {
    searchParams.set("page", String(params.page));
  }

  if (params.pageSize != null) {
    searchParams.set("pageSize", String(params.pageSize));
  }

  if (params.institutionId) {
    searchParams.set("institutionId", params.institutionId);
  }

  if (params.tnuaId) {
    searchParams.set("tnuaId", params.tnuaId);
  }

  const query = searchParams.toString();
  return requestJson(`/api/ranking${query ? `?${query}` : ""}`);
}
